import { graphql } from "@repo/graphql-types/gql";
import type {
  EtapaDoFluxoPendenteType,
  FluxoPendenteDoUsuarioType,
} from "@repo/graphql-types/graphql";

import { useGraphQL } from "@/hooks/use-graphql";

export const FlowsDataQuery = graphql(/* GraphQL */ `
  query FlowsDataQuery {
    membro {
      fluxosPendentes: fluxos(where: { status: { eq: "PENDENTE" } }) {
        codFluxo
        codProximoFluxo
        versao
        status
        configuracoes
        obrigatorio
        etapas {
          codEtapa
          codEtapaUsuario
          dataConcluido
          dataCadastro
          descricao
          status
          configuracoes
          obrigatorio
          resposta
        }
      }
    }
  }
`);

const SKIPPED_STATUSES = new Set(["IGNORADO", "CONCLUIDO"]);

export const isStepSkippable = (step: EtapaDoFluxoPendenteType): boolean =>
  Boolean(step.status && SKIPPED_STATUSES.has(step.status));

export const getActiveSteps = (
  flow: FluxoPendenteDoUsuarioType | undefined,
): EtapaDoFluxoPendenteType[] =>
  (flow?.etapas ?? []).filter((s): s is EtapaDoFluxoPendenteType => s !== null);

export const useFlowData = () => useGraphQL(FlowsDataQuery);
